// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirmation[data-v-25115807]{display:flex;flex-direction:column}.confirmation__icon[data-v-25115807]{padding-top:80px}.confirmation__warning[data-v-25115807]{margin-top:10px;text-align:center}.confirmation__copy-link[data-v-25115807]{margin:50px auto 0 auto}\n", ""]);
// Exports
module.exports = exports;
